import { render, staticRenderFns } from "./we-series-view.vue?vue&type=template&id=fb3f8414&scoped=true"
import script from "./we-series-view.vue?vue&type=script&lang=js"
export * from "./we-series-view.vue?vue&type=script&lang=js"
import style0 from "./we-series-view.vue?vue&type=style&index=0&id=fb3f8414&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3f8414",
  null
  
)

export default component.exports